import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function Dashboard() {
  return (
    <>
      <Helmet>
        <title> Dashboard | Ennovation Austria</title>
      </Helmet>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "84vh",
          backgroundImage: 'url(https://cdn.prod.website-files.com/65f03c978efea1c906592c94/65f300b982243934e5c9ae8a_AdobeStock_535186049_gruen_klein.webp)',
          backgroundSize: '100% 100%',
          backgroundRepeat: 'no-repeat'
          // background: "linear-gradient(to left, #0BD349, #000000)",
        }}
      >
        <Container
          maxWidth="sm"
          sx={{
            backgroundColor: "rgb(255, 255, 255, 0.9)",
            padding: 4,
            borderRadius: "16px",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
          }}
        >
          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: "bold",
              color: "#333",
            }}
          >
            {/* Welcome to Ennovation Dashboard! */}
            Willkommen beim Ennovation Dashboard!
          </Typography>

          <Typography
            variant="body1"
            gutterBottom
            sx={{
              color: "#666",
              marginBottom: 3,
            }}
          >
            {/* Manage your listings with ease. Let's get started by exploring the
          features or adding your first listing! */}
            Verwalten Sie Ihre Einträge ganz einfach. Beginnen wir damit, die Funktionen zu erkunden oder Ihren ersten Eintrag hinzuzufügen!
          </Typography>
          <Link to="/dashboard/listings">
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#0BD349",
                color: "#000",
                padding: "12px 24px",
                fontSize: "16px",
                borderRadius: "8px",
                "&:hover": {
                  backgroundColor: "#098B2B",
                },
              }}
            >
              {/* Go to Listings */}
              Gehen Sie zu Einträge
            </Button>
          </Link>
        </Container>
      </Box>
    </>
  );
}

export default Dashboard;
